var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center flex-wrap align-items-center",class:_vm.$style.wrapper},[_vm._t("default",null,null,{ itemClass: _vm.$style.item })],2)}
var staticRenderFns = []

export { render, staticRenderFns }